import { just } from 'readuz';
import { CXF } from '../typings/cxf';
import { App, app, SubscribeToCxf, subscribeToCxf } from './app';
import { DIReader } from './common';
import { Config, createConfig } from './config';
import { OnTrack, onTrack } from './event-handlers';
import {
    entityProvider,
    IProvider,
    Log,
    log,
    LogError,
    logError,
    loadCxf,
    LoadCxf,
    TryCatch,
    tryCatch,
} from './helpers';
import { TrackAction, trackAction } from './track';

export interface IEnv {
    config: DIReader<Config>;

    cxfProvider: DIReader<IProvider<CXF>>;
    dialogProvider: DIReader<IProvider<HTMLElement>>;

    log: DIReader<Log>;
    logError: DIReader<LogError>;

    onTrack: DIReader<OnTrack>;

    app: DIReader<App>;
    subscribeToCxf: DIReader<SubscribeToCxf>;
    trackAction: DIReader<TrackAction>;
    loadCxf: DIReader<LoadCxf>;
    tryCatch: DIReader<TryCatch>;
}

export const createEnv = (env: Partial<IEnv>): IEnv => {
    return {
        config: just(createConfig({})),

        cxfProvider: just(entityProvider()),
        dialogProvider: just(entityProvider()),

        log: just(log),
        logError: just(logError),

        app,
        subscribeToCxf,
        onTrack,
        trackAction,
        loadCxf: just(loadCxf),
        tryCatch,
        ...env,
    };
};
